import { render, staticRenderFns } from "./FollowingRecordsTable.vue?vue&type=template&id=04f3d996"
import script from "./FollowingRecordsTable.vue?vue&type=script&lang=js"
export * from "./FollowingRecordsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports